import { Link } from 'react-router-dom';

const quickLinks = [
  { name: '热门推荐', path: '/category/recommended' },
  { name: '电影大片', path: '/category/movies' },
  { name: '电视剧', path: '/category/tv-series' },
  { name: '动漫', path: '/category/anime' },
  { name: '综艺', path: '/category/variety' },
  { name: '纪录片', path: '/category/documentary' },
];

const aboutLinks = [
  { name: '关于我们', path: '/about' },
  { name: '联系方式', path: '/about#contact' },
  { name: '用户协议', path: '/about' },
  { name: '隐私政策', path: '/about' },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="py-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-fire-line text-lg text-white"></i>
                </div>
                <span className="text-xl font-bold font-heading text-white">
                  欲火视频
                </span>
              </div>
              <p className="text-sm text-secondary-300 leading-relaxed">
                欲火视频是专业的在线视频平台，提供海量高清影视资源，让您随时随地畅享极致视听体验。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">
                <a href="/category/recommended" className="hover:text-accent-400 transition-colors">热门分类</a>
              </h4>
              <ul className="space-y-2.5">
                {quickLinks.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-secondary-300 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">
                <a href="/about" className="hover:text-accent-400 transition-colors">关于</a>
              </h4>
              <ul className="space-y-2.5">
                {aboutLinks.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-secondary-300 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">联系我们</h4>
              <ul className="space-y-2.5 text-sm text-secondary-300">
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line mt-0.5 text-accent-400"></i>
                  <span>contact@yuhuo.com</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line mt-0.5 text-accent-400"></i>
                  <span>400-888-8888</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line mt-0.5 text-accent-400"></i>
                  <span>北京市朝阳区影视产业园区</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-secondary-700/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-secondary-400">
              &copy; {new Date().getFullYear()} 欲火视频 Yuhuo Video. All rights reserved.
            </p>
            <div className="flex items-center gap-5">
              <a href="#" className="text-secondary-400 hover:text-accent-400 transition-colors" rel="nofollow" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="text-secondary-400 hover:text-accent-400 transition-colors" rel="nofollow" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="text-secondary-400 hover:text-accent-400 transition-colors" rel="nofollow" aria-label="哔哩哔哩">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}